<div class="inventory-modal">
  <div class="inventory-modal__header">
    <span class="inventory-modal__title">{{'Quick Idler Setup ' | translate | async}} </span>
    <i class="material-icons inventory-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <!-- <div class="center" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div> -->
  <div class="inventory-modal__body">

    <div class="body">


      <mat-form-field class="search-input">
        <mat-select (selectionChange)="customerChanged($event)" name="customer" placeholder="{{Translate('Select Customer')}}">
          <mat-option *ngFor="let customer of _dropDownLists.customerList" [value]="customer">
            {{ customer.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="search-input">
        <mat-select (selectionChange)="jobsiteChanged($event)" [(value)]="selectedJobsite" name="jobsite"
          placeholder="{{Translate('Select Job Site')}}">
          <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
            {{ jobsite.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="search-input">
        <mat-select (selectionChange)="makeChanged($event)" [(value)]="selectedMake" name="make" placeholder="{{Translate('Select Make')}}">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- <mat-form-field class="search-input">
        <mat-select (selectionChange)="modelChanged()" [(ngModel)]="selectedModel" name="model"
          placeholder="{{Translate('Select Model')}}">
          <mat-option *ngFor="let model of modelList" [value]="model.Id">
            {{ model.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <!-- <mat-form-field  class="search-input">
        <input type="text" placeholder="Model"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto">
        <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" (click)="modelselect()" #auto="matAutocomplete">
           <mat-option [value]="model.Name" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field> -->

      <mat-form-field  class="search-input">
        <input type="text" placeholder="Model"  (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto_">
        <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel"  #auto_="matAutocomplete" (optionSelected)="modelselect($event.option.value)">
           <mat-option [value]="model.Name" *ngFor="let model of modelList" >
            {{model.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

    




      <mat-form-field class="search-input">
        <mat-select  placeholder="Select a Idler"  [(ngModel)]="selectedidler" name="system">
          <mat-option *ngFor="let system of componentList" [value]="system.CompartId">
            {{system.Name}} 
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field >
        <input matInput  #start_Date="ngModel" 
        [(ngModel)]="selected_date" [matDatepicker]="picker" placeholder="Choose a date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>


      <mat-form-field class="input-full-width">
        <input matInput placeholder="{{ 'Customer Reference' | translate | async }}" [(ngModel)]="selected_customerRef" (input)="getCusRef($event)">
      </mat-form-field>
    </div>

    <div class="flex-horizontal set-margin">
    
      <mat-form-field class="input-full-width">
        <input matInput placeholder="{{ 'Job Number' | translate | async }}" [(ngModel)]="selected_jobNumber" (input)="getJobNumber($event)">
      </mat-form-field>
  
      <mat-form-field class="input-full-width ">
        <input matInput placeholder="{{ 'Old Job No.' | translate | async }}" [(ngModel)]="selected_oldJobNo" (input)="getOldJobNumber($event)">
      </mat-form-field>
  
      
    </div>
  </div>

  <div  class="item-align-end">
    <button mat-raised-button color="warn" (click)="onClickStartInspection()">{{'Start Inspection' | translate | async}}</button>
  </div>
</div>